import { Carousel } from "@mantine/carousel";
import { Button, Flex, Group, Stack, Text } from "@mantine/core";
import { useFlashcardStyles } from "./FlashCard";
import classes from "./FlashCardReviewCard.module.css";

export default function FlashCardReviewCard({
  subjectColorIndex,
  reviewCardsCount,
  setIsReviewingHandler,
}: {
  subjectColorIndex: string;
  reviewCardsCount: number;
  setIsReviewingHandler: (reset?: true) => void;
}) {
  const { classes: flashcardClasses, style } = useFlashcardStyles({
    subjectColorIndex,
    front: true,
  });
  const { title, subtitle } = getReviewCardText(reviewCardsCount);
  return (
    <Carousel.Slide className={flashcardClasses.card} style={style}>
      <Stack className={flashcardClasses.cardSide} gap={0}>
        <Flex className={classes.flexContainer}>
          <Text className={classes.title}>{title}</Text>
          <Text className={classes.reviewText}>{subtitle}</Text>
          <Group className={classes.buttonGroup}>
            <Button
              name={reviewCardsCount === 0 ? "Restart" : "Reset"}
              className={classes.button}
              onClick={() => {
                setIsReviewingHandler(true);
              }}
            >
              {reviewCardsCount === 0 ? "Restart" : "Reset"}
            </Button>
            {reviewCardsCount > 0 && (
              <Button
                name={"Review"}
                className={classes.button}
                onClick={() => {
                  setIsReviewingHandler();
                }}
              >
                {"Review"}
              </Button>
            )}
          </Group>
        </Flex>
      </Stack>
    </Carousel.Slide>
  );
}

function getReviewCardText(reviewCardsCount: number): {
  title: string;
  subtitle: string;
} {
  const noReview = reviewCardsCount === 0;
  const title = noReview ? "Great work!" : "Nearly there!";
  const subtitle = `You ${!noReview ? "only " : ""}have ${
    noReview ? "no" : reviewCardsCount
  } card${reviewCardsCount === 1 ? "" : "s"} left to review`;

  return { title, subtitle };
}
